import { render, staticRenderFns } from "./detailLayoutMent.vue?vue&type=template&id=7b6a5e6a&"
import script from "./detailLayoutMent.vue?vue&type=script&lang=js&"
export * from "./detailLayoutMent.vue?vue&type=script&lang=js&"
import style0 from "./detailLayoutMent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b6a5e6a')) {
      api.createRecord('7b6a5e6a', component.options)
    } else {
      api.reload('7b6a5e6a', component.options)
    }
    module.hot.accept("./detailLayoutMent.vue?vue&type=template&id=7b6a5e6a&", function () {
      api.rerender('7b6a5e6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/model/agreeDetail/detailLayoutMent.vue"
export default component.exports